module.exports = {
    clearAll: function() {
        window.localStorage.clear();
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/Managers/Storage.js
 **/